/**
 * Ligne liste paramètres (style Secteurs) : libellé, slot optionnel (ex. sélecteur utilisateurs), actions à droite.
 */
const SettingsEntityRow = ({ label, middleSlot, actionsSlot }) => (
  <div className="flex w-full min-w-0 items-center justify-between gap-4 border-b border-gray-100 px-4 py-4 text-sm">
    <div className="min-w-0 flex-1 truncate font-medium text-gray-900">
      {label}
    </div>
    <div className="flex min-w-0 items-center gap-6">
      {middleSlot != null ? (
        <div className="min-w-0 max-w-[160px] flex-1 basis-[160px]">
          {middleSlot}
        </div>
      ) : null}
      {actionsSlot != null ? (
        <div className="flex shrink-0 gap-1">{actionsSlot}</div>
      ) : null}
    </div>
  </div>
);

export default SettingsEntityRow;
